export default interface Paginated<K> {
  total: number;
  perPage: number;
  currentPage: number;
  lastPage: number;
  pageElements: K[];
}

type PageMapper<K, O> = (paginated: Paginated<K>) => Paginated<O>;

export function pageMapperBuilder<K, O>(mapFn: (elemet: K) => O): PageMapper<K, O> {
  return (paginated: Paginated<K>) => ({
    ...paginated,
    pageElements: paginated.pageElements?.map(mapFn)
  });
}
